(function () {
  const b2bPage = document.getElementById("b2b_page");
  if (!b2bPage) return;

  const stickyMediaQuery = window.matchMedia("(min-width: 1024px)");
  const sections = Array.from(b2bPage.querySelectorAll("section"));

  function updateStickyTops() {
    if (!stickyMediaQuery.matches) {
      sections.forEach((section) => {
        section.style.removeProperty("--b2b-sticky-top");
      });
      return;
    }

    const viewportHeight = window.innerHeight;

    sections.forEach((section) => {
      if (getComputedStyle(section).position !== "sticky") {
        section.style.removeProperty("--b2b-sticky-top");
        return;
      }

      const top = Math.min(0, viewportHeight - section.offsetHeight);
      section.style.setProperty("--b2b-sticky-top", `${top}px`);
    });
  }

  let resizeFrame;
  function scheduleUpdate() {
    cancelAnimationFrame(resizeFrame);
    resizeFrame = requestAnimationFrame(updateStickyTops);
  }

  updateStickyTops();

  window.addEventListener("resize", scheduleUpdate);
  stickyMediaQuery.addEventListener("change", scheduleUpdate);

  if (typeof ResizeObserver !== "undefined") {
    const observer = new ResizeObserver(scheduleUpdate);
    sections.forEach((section) => observer.observe(section));
  }

  b2bPage.querySelectorAll("img").forEach((img) => {
    if (!img.complete) {
      img.addEventListener("load", scheduleUpdate, { once: true });
    }
  });

  if (document.fonts?.ready) {
    document.fonts.ready.then(scheduleUpdate);
  }
})();
